const indexedDB = window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB;

export const OpenTabIndexedDB = () => {
  return new Promise((resolve, reject) => {
    if (!indexedDB) throw new Error("Your browser doesn't support IndexedBD");

    const request = indexedDB.open("TabDB", 1);

    request.onerror = (e) => {
      console.error(`IndexedDB error: ${request.errorCode}`);
      resolve(null);
    };

    request.onsuccess = (e) => {
      const db = e.target.result;
      resolve(db);
    };

    request.onupgradeneeded = (e) => {
      const db = e.target.result;
      db.createObjectStore("tab", { keyPath: "id", autoIncrement: true });
    };
  });
};

export const AddTabToIndexedDB = () => {
  return new Promise(async (resolve, reject) => {
    const db = await OpenTabIndexedDB();
    const request = db
      .transaction(["tab"], "readwrite")
      .objectStore("tab")
      .add({ isActive: true, merchantId: 0 });

    request.onsuccess = (event) => {
      var tabId = event.target.result;
      db.close();
      resolve(tabId);
    };
    request.onerror = (err) => {
      console.error(`Error to add new Tab: ${err}`);
      db.close();
      resolve(0);
    };
  });
};

export const UpdateTabMerchantIdToIndexedDB = (tabId, merchantId) => {
  return new Promise(async (resolve, reject) => {
    const db = await OpenTabIndexedDB();
    const objectStore = db.transaction(["tab"], "readwrite").objectStore("tab");

    const request = objectStore.get(tabId);

    request.onsuccess = () => {
      const tab = request.result;
      tab.merchantId = merchantId;
      const updateRequest = objectStore.put(tab);
      updateRequest.onsuccess = () => {
        db.close();
        resolve(true);
      };

      request.onerror = (err) => {
        console.error(`Error to update merchant id tab: ${err}`);
        db.close();
        resolve(false);
      };
    };
  });
};

export const RemoveTabFromIndexedDB = (tabId) => {
  return new Promise(async (resolve, reject) => {
    const db = await OpenTabIndexedDB();
    const request = db
      .transaction(["tab"], "readwrite")
      .objectStore("tab")
      .delete(tabId);
    request.onsuccess = (event) => {
      db.close();
      resolve(true);
    };
    request.onerror = (err) => {
      console.error(`Error to remove new tab: ${err}`);
      db.close();
      resolve(false);
    };
  });
};

export const GetAllTabsFromIndexedDB = () => {
  return new Promise(async (resolve, reject) => {
    const db = await OpenTabIndexedDB();
    const request = db
      .transaction(["tab"])
      .objectStore("tab")
      .getAll();

    request.onsuccess = () => {
      const tabs = request.result;
      db.close();
      resolve(tabs);
    };

    request.onerror = (err) => {
      console.error(`Error to get all tabs: ${err}`);
      db.close();
      resolve([]);
    };
  });
};

export const GetTabByIdFromIndexedDB = (tabId) => {
  return new Promise(async (resolve, reject) => {
    const db = await OpenTabIndexedDB();
    const request = db
      .transaction(["tab"])
      .objectStore("tab")
      .get(tabId);

    request.onsuccess = () => {
      const tab = request.result;
      db.close();
      resolve(tab);
    };

    request.onerror = (err) => {
      console.error(`Error to get tab: ${err}`);
      db.close();
      resolve(null);
    };
  });
};

export const DeleteTabFromIndexedDB = () => {
  return new Promise((resolve, reject) => {
    if (!indexedDB) throw new Error("Your browser doesn't support IndexedBD");
    const request = indexedDB.deleteDatabase("TabDB");

    request.onerror = (event) => {
      console.error("Error deleting database.");
      resolve(false);
    };

    request.onblocked = (event) => {
      console.error("blocked: " + event);
    };

    request.onsuccess = (event) => {
      resolve(true);
    };
  });
};

export const CheckIndexedDBIsSupport = () => {
  return indexedDB ? true : false;
};
